// Ce fichier est le fichier d'inclusion des js depuis laravel 9.
require('./FileInput/main-file');

import DatePicker from './DatePicker';
customElements.define('core-date-picker',DatePicker,{extends: 'div'});

import Select2 from './Select2';
customElements.define('core-select2', Select2,{extends: 'div'});

import Summernote from './Summernote';
customElements.define('core-summernote', Summernote,{extends: 'div'});